import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { SampleComponent } from './sample.component';
import { CustomSnackbarComponent } from '../../shared/components/custom-snackbar/custom-snackbar.component';



const routes = [
    {
        path     : 'sample',
        component: SampleComponent
    }
];

@NgModule({
    declarations: [
        SampleComponent, 
        CustomSnackbarComponent
    ],
    imports     : [
        RouterModule.forChild(routes),

        TranslateModule,

        FuseSharedModule
    ],
    exports     : [
        SampleComponent
    ],
    entryComponents: [
        CustomSnackbarComponent
      ]
})

export class SampleModule
{
}
